/**
 * Contains general utility methods.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class GeneralUtility {
  /**
   * Gets a property from the `Global` variable. If the property is not found, an error is thrown.
   *
   * @param {string} name Name of the property to get
   * @returns {any} Property value, if found
   */
  public static getGlobalProperty(name: string): any {
    if (SfEventMgtThGlobals === undefined || !SfEventMgtThGlobals) {
      throw new Error('Globals are missing.');
    }
    if (SfEventMgtThGlobals[name] === undefined || !SfEventMgtThGlobals.hasOwnProperty(name)) {
      throw new Error('Property ' + name + ' not found in globals.');
    }
    return SfEventMgtThGlobals[name];
  }

  /**
   * Gets the current page URL.
   *
   * @param {string} [additionalParameters=[]] Additional GET parameters to add to the URL
   * @param {boolean} [keepParameters=false] Whether to keep current URL parameters, or to throw them away
   * @param {boolean} [keepHash=false] Whether to keep current URL hash, or to throw it away
   * @returns {string} Current URL without a trailing slash
   */
  public static getUrl(
    additionalParameters: string[] = [],
    keepParameters: boolean = false,
    keepHash: boolean = false
  ): string {
    // Parse base URL
    const originalUrl = window.location.href;
    let baseUrl = originalUrl.split('?')[0].split('#')[0];
    if (baseUrl.charAt(baseUrl.length - 1) === '/') {
      baseUrl = baseUrl.substring(0, baseUrl.length - 1);
    }
    const hash = window.location.hash;

    // Extract current parameters
    let parameters = '';
    const parts = originalUrl.match(new RegExp(/\?(.*)$/));
    if (parts !== null && parts.length === 2) {
      parameters = parts[1].replace(hash, '');
    }

    // Build the final URL
    let url = baseUrl;
    if (keepParameters && parameters !== '') {
      url += `?${parameters}`;
    }
    if (additionalParameters.length > 0) {
      url += (url.includes('?') ? '&' : '?') + additionalParameters.join('&');
    }
    if (keepHash && hash !== '') {
      url += hash;
    }

    return url;
  }
}
